// TaskDetailsModal.js
import React from 'react';
import { Modal, Button, Card, Accordion } from 'react-bootstrap';
import './TaskDetailsModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';

const TaskDetailsModal = ({ show, onHide, task, onRefresh }) => {
  if (!task) return null;

  // Determine whether this is a template (no logs) or a real task
  const isTemplate = task.templateId !== undefined;

  const statusDictionary = {
    success: 'bg-success',
    error:   'bg-danger'
  };

  const title = isTemplate ? 'Template Details' : 'Task Details';

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      className="task-details-modal"
      dialogClassName="task-details-modal-dialog modal-90w"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Only show status/timeline if this is NOT a template */}
        {!isTemplate && (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <h5>Current Status</h5>
              <button
                className="btn btn-outline-primary ms-3"
                onClick={onRefresh}
              >
                <FontAwesomeIcon icon={faRefresh} />
              </button>
            </div>

            <div className="timeline">
              {task.logs?.map((log, index) => (
                <div key={log.id} className="timeline-item">
                  <div className={`circle ${statusDictionary[log.status]}`}>
                    {index + 1}
                  </div>
                  {index < task.logs.length - 1 && (
                    <div className={`arrow ${statusDictionary[log.status]}`} />
                  )}
                  <div className="step-details">
                    <div className="step-name">{log.stepName}</div>
                    <div className="description">{log.description}</div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {/* Always show parameters */}
        <Accordion className="parameters-accordion mt-4">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <h5>Parameters</h5>
            </Accordion.Header>
            <Accordion.Body>
              <div className="parameters-list">
                {task.parametersUsed.map(param => (
                  <Card key={param.id} className="mb-3 parameter-used-card">
                    <Card.Body>
                      <div className="parameter-name">
                        {param.parameterName}
                      </div>
                      <ul className="values-list list-group mt-2">
                        {param.valuesUsed
                          .split(',')
                          .map((value, idx) => (
                            <li className="list-group-item" key={idx}>
                              {value === '-1' ? 'All' : value}
                            </li>
                          ))}
                      </ul>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TaskDetailsModal;
